import { BaseModel } from '../../_base/crud';

export class AccessModel  extends BaseModel {
	menuKartanu: boolean;
  }
